export default "__VITE_ASSET__2WPE8msv__"